import { lazy } from 'react';
const OrderDashboard = lazy(() => import('./OrderDashboard'));

const OrderDashboardRoutes = [
  {
    path: '/orderdashboard',
    component: OrderDashboard
  }
];

export default OrderDashboardRoutes;
